import React from 'react';
import { getClassNameFactory, getRehydratableName } from '@dcl/ui';
import { propsToDataAttributes } from '@tr-digital/react-rehydrate';
import { ArticleVideo } from './templates/ArticleVideo/ArticleVideo';
import { ArticleVideoPlayList } from './templates/ArticleVideoPlayList/ArticleVideoPlayList';
import { articleVideoTemplateType } from './mock';
import { IVideoArticleList } from './types';

export const VideoArticleList: React.FC<IVideoArticleList> = (
  props: IVideoArticleList
) => {
  const {
    heading,
    articles,
    videoPlaylist,
    template,
    articleVideoMixed = [],
    partnerId = '',
    privileges = '',
    secretKey = '',
  } = props;
  const getClassName = getClassNameFactory(VideoArticleList.displayName);

  let renderTemplate: JSX.Element;

  if (template === articleVideoTemplateType) {
    renderTemplate = (
      <ArticleVideo
        heading={heading}
        articleVideoMixed={articleVideoMixed}
        privileges={privileges}
        partnerId={partnerId}
        secretKey={secretKey}
      />
    );
  } else {
    renderTemplate = (
      <ArticleVideoPlayList
        articles={articles}
        videoPlayList={videoPlaylist}
        heading={heading}
      />
    );
  }

  return (
    <div
      className={getClassName()}
      data-rehydratable={getRehydratableName(VideoArticleList.displayName)}
      {...propsToDataAttributes(props)}
    >
      {renderTemplate}
    </div>
  );
};

VideoArticleList.displayName = 'VideoArticleList';
